module.exports = __webpack_public_path__ + "fonts/539c02d4d3794d54578e906fe282220c.svg";